import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import mediaQueries from '../styles/mediaQueries';

const PageContainer = styled.div`
  max-width: 100%;
  overflow-x: hidden;
  font-family: var(--font-primary);
  padding: 0 20px 0px;
`;

const MainSection = styled.main`
  max-width: 900px;
  margin: 80px auto 40px;
  font-family: var(--font-primary);
  
  ${mediaQueries.medium} {
    margin: 60px auto 30px;
  }
  
  ${mediaQueries.small} {
    margin: 40px auto 20px;
  }
`;

const Title = styled.h1`
  font-size: 32px;
  margin-bottom: 30px;
  color: ${({theme}) => theme.colors.primary};
  
  ${mediaQueries.small} {
    font-size: 28px;
  }
`;

const Subtitle = styled.h2`
  font-size: 24px;
  margin: 30px 0 20px;
  color: ${({theme}) => theme.colors.secondary};
  
  ${mediaQueries.small} {
    font-size: 20px;
  }
`;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const CompanyName = styled.strong`
  font-weight: var(--font-weight-semibold);
`;

const InfoBlock = styled.div`
  margin-bottom: 20px;
`;

const UpdateDate = styled.p`
  font-size: 14px;
  font-style: italic;
  margin-top: 40px;
  color: ${({theme}) => theme.colors.darkGray};
`;

const MentionsLegales: React.FC = () => {
  return (
    <PageContainer>
      <SEO 
        title="Mentions légales" 
        description="Mentions légales du site thinkfab.fr. Informations sur l'éditeur du site, l'hébergement et la propriété intellectuelle."
        canonical={`${window.location.origin}/mentions-legales`}
      />
      <Header backgroundColor="transparent" textColor="#DD3114" />
      
      <MainSection>
        <Title>Mentions Légales</Title>
        
        <Subtitle>Édition du site</Subtitle>
        <InfoBlock>
          <Paragraph>Le site internet thinkfab.fr est édité par :</Paragraph>
          <Paragraph>
            <CompanyName>Thinkfab SAS</CompanyName><br />
            Société par Actions Simplifiée au capital de 3500 euros<br />
            Siège social : 17 rue Bernegger<br />
            RCS : Strasbourg B 533118733<br />
            SIRET : 53311873300021<br />
            N° TVA Intracommunautaire : FR35533118733<br />
            Téléphone : +33954570018<br />
            Email : info@thinkfab.fr
          </Paragraph>
        </InfoBlock>
        
        <Subtitle>Direction de la publication</Subtitle>
        <Paragraph>
          Le site thinkfab.fr est dirigé par :<br />
          Fabrice PAPST, agissant en qualité de président
        </Paragraph>
        
        <Subtitle>Hébergement</Subtitle>
        <Paragraph>
          Le site thinkfab.fr est hébergé par :<br />
          Scaleway<br />
          Société par Actions Simplifiée au capital de 214 410,50 Euros<br />
          8 rue de la Ville l’Evêque, 75008 Paris<br />

        </Paragraph>
        
        <Subtitle>Propriété intellectuelle</Subtitle>
        <Paragraph>
          L'ensemble des éléments constituant le site thinkfab.fr (textes, graphismes, logiciels, photographies, images, vidéos, sons, plans, logos, marques, etc.) ainsi que le site lui-même, relèvent des législations françaises et internationales sur le droit d'auteur et la propriété intellectuelle.
        </Paragraph>
        <Paragraph>
          "Wedodev" est une marque déposée et protégée. Toute reproduction ou représentation, totale ou partielle, est strictement interdite sans autorisation.
        </Paragraph>
        <Paragraph>
          Thinkfab SAS est propriétaire des droits de propriété intellectuelle ou détient les droits d'usage sur tous les éléments accessibles sur le site, y compris les logiciels, bases de données, interfaces, contenus textuels et visuels.
        </Paragraph>
        
        <Subtitle>Limitation de responsabilité</Subtitle>
        <Paragraph>
          Thinkfab SAS ne pourra être tenue responsable des dommages directs ou indirects résultant de l'utilisation du site thinkfab.fr ou d'autres sites qui lui sont liés, notamment du fait d'une interruption, d'un dysfonctionnement, d'une suspension ou de la fin de la mise à disposition du site pour quelque raison que ce soit.
        </Paragraph>
        
        <Subtitle>Loi applicable et juridiction</Subtitle>
        <Paragraph>
          Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
        </Paragraph>
        
        <Subtitle>Modifications des mentions légales</Subtitle>
        <Paragraph>
          Thinkfab SAS se réserve le droit de modifier les présentes mentions légales à tout moment. L'utilisateur est invité à les consulter régulièrement.
        </Paragraph>
        
        <UpdateDate>Dernière mise à jour : 23/04/2025</UpdateDate>
      </MainSection>
      
      <Footer />
    </PageContainer>
  );
};

export default MentionsLegales;